<script lang="ts" setup>
import type { HeadingData } from '~/components/atoms/Heading.vue'

defineProps<{
  title?: HeadingData
  subTitle?: string | null
}>()
</script>

<template>
  <div v-if="title" class="section-title t-7 tl-5">
    <Heading v-animate="{ animation: 'vertical-reveal' }" class="title text-xlarge" :data="title" />
    <div v-if="subTitle" v-animate="{ animation: 'vertical-reveal' }" class="sub-title text-medium" v-html="subTitle" />
  </div>
</template>

<style lang="scss" scoped>
.section-title {
  --c-title: var(--c-primary);
  --c-subtitle: var(--c-text-medium);
  margin-bottom: var(--margin-small);

  > :last-child {
    margin-bottom: 0;
  }
}
.title {
  color: var(--c-title);
}
.sub-title {
  color: var(--c-subtitle);
  > :deep(*:last-child) {
    margin-bottom: 0;
  }
}
</style>
